import * as COMMON_CONFIG from '@flyblack/common/config';

export const { API, GOOGLE_API_KEY, ENVIRONMENT, SENTRY_DSN, RELEASE } = COMMON_CONFIG;

declare var CONFIG: {
  CLIENT_ID: string;
};

export const { CLIENT_ID } = CONFIG;
